import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export default function VisuallyHiddenText({ children }: Props) {
  return <span className="sr-only">{children}</span>;
}
